export const checkPasswordStrength = (inputValue: string) => {
  const min8Characters = inputValue.length >= 8;
  const atLeast1UppercaseLetter = /^(?=.*[A-Z]).+$/;
  const atLeast1Number = /^.*[0-9].*/;

  return [
    {
      isValid: min8Characters,
      title: 'Minimum 8 characters',
    },
    {
      isValid: atLeast1UppercaseLetter.test(inputValue),
      title: 'Minimum 1 capital letter',
    },
    {
      isValid: atLeast1Number.test(inputValue),
      title: 'Minimum 1 number',
    },
  ];
};
